import { render, staticRenderFns } from "./TopButtonWithIcon.vue?vue&type=template&id=18ecf5b8&scoped=true&"
import script from "./TopButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./TopButtonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./TopButtonWithIcon.vue?vue&type=style&index=0&id=18ecf5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecf5b8",
  null
  
)

export default component.exports